var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plus",style:(_vm.strokePosition)},[_c('svg',{attrs:{"fill":"none","height":"21","viewBox":"0 0 22 21","width":"22","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"stroke":_vm.plusColor,"d":"M10.8262 21V0"}}),_c('path',{attrs:{"stroke":_vm.plusColor,"d":"M21.3262 10.5L0.326172 10.5"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }